/**
 * Active href
 * - add class to every <a> which have current URL
 * ==============================================
 */
var currentPage = location.href
var currentPage = currentPage.replace(/^[a-z]{4}\:\/{2}[a-z]{1,}\:[0-9]{1,4}.(.*)/, '$1')
var currentPage = currentPage.replace(/^.*\/\/[^\/]+/, '')
var currentPage = currentPage.replace('/', '')

$('.nav a').each(function() {
    var currentHref = $(this).attr('href')

    if(currentHref == currentPage) {
        $(this).parent().addClass("is-active")
    }
})
